import { ICellRendererParams } from 'ag-grid-community'

import { InitialsAvatar } from '../components'

import React from 'react'

import Spinner from '@/components/Spinner'
import { useGetStaffUsersQuery } from '@/services/user'

import { PlusSmallIcon } from '@heroicons/react/20/solid'

export function DealTeamRenderer(params: ICellRendererParams) {
  const { data: staffUsers, isLoading } = useGetStaffUsersQuery()

  const dealTeams = params.value?.map((dealTeam) => ({
    type: dealTeam.type,
    user: staffUsers?.find((u) => u.id === dealTeam.user),
  }))

  return (
    <div className='inline-flex flex-row-reverse flex-nowrap'>
      {isLoading ? (
        <Spinner size={4} />
      ) : (
        <>
          {dealTeams?.length > 0 ? (
            <>
              {dealTeams?.map((dealTeam) => {
                return (
                  <InitialsAvatar
                    key={dealTeam?.user?.id}
                    user={dealTeam.user}
                    type={dealTeam.type}
                  />
                )
              })}
            </>
          ) : (
            <PlusSmallIcon
              width={22}
              height={22}
              className='bg-gray-400 hover:bg-gray-500 rounded-full text-white ring-2 ring-white cursor-pointer'
            />
          )}
        </>
      )}
    </div>
  )
}
